module.exports = __webpack_public_path__ + "static/store-hours-c24d79f4aeac9fe6a00345920cddbecb.gif";